export enum InsightsApiErrorTypes {
  LoadInsightsError,
  PermissionsError,
  GuardError,
}

export class InsightsApiError {
  constructor(public type: InsightsApiErrorTypes, public error: Error) {}
}
